export const URLS = {
  GRUPO_SURA: 'https://www.gruposura.com',
  SURA_ASSET_MANAGEMENT: 'https://invierteyahorra.suramexico.com/suramexico/',
  SURAMERICANA: 'https://www.suramericana.com/index.html',
  FUNDACION_SURA: 'https://www.fundacionsura.com/',
  CDMX: 'https://www.segurossura.com.mx/oficinas/corporativo/',
  LISTA_OFICINAS: '',
  CONDICIONES_GENERALES: 'https://www.segurossura.com.mx/condiciones-generales/',
  BASICOS_ESTANDARIZADOS: 'https://www.segurossura.com.mx/personas/basicos-estandarizados/',
  RED_MEDICA: 'https://www.segurossura.com.mx/wp-content/uploads/2024/05/Red-Medica-052024.xlsx',
  TABULADOR_QUIRURGICO: 'https://www.segurossura.com.mx/tabulador-quirurgico/',
  GEOSURA: 'https://geo.sura.com/principal/',
  TALENTO_HUMANO: 'https://www.segurossura.com.mx/talento-humano/',
  AVISO_PRIVACIDAD: 'https://qa-portal.segurossura.com.mx/legales/aviso-de-privacidad/',
  ATENCION_USUARIOS:
    'https://www.segurossura.com.mx/legales/unidad-especializada-de-atencion-a-usuarios-une/',
  SEGURIDAD_INFORMATICA: 'https://www.segurossura.com.mx/legales/seguridad-informatica/',
  POLITICA_IDENTIFICACION:
    'https://www.segurossura.com.mx/legales/politica-de-identificacion-y-conocimiento-del-cliente/',
  LINEA_ETICA: 'https://www.segurossura.com.mx/legales/linea-etica/',
  FACEBOOK: 'https://www.facebook.com/SegurosSURAMexico/',
  INSTAGRAM: 'https://www.instagram.com/segurossuramx/',
  LINKEDIN: 'https://www.linkedin.com/company/seguros-sura/?viewAsMember=true',
  PAYMENT_AVISO_PAGO:
    'https://www.segurossura.com.mx/wp-content/uploads/2022/06/Aviso-pago-recurrente-seguros-sura.pdf',
  PAYMENT_AVISO_PRIVACIDAD: 'https://www.segurossura.com.mx/legales/aviso-de-privacidad/',
  USO_MEDIOS_ELECTRONICOS: 'https://www.segurossura.com.mx/legales/uso-de-medios-electronicos/',
};

export const footerItem = {
  segurosSura: [
    {
      title: 'Acerca de SURA',
      url: '',
    },
    {
      title: 'Grupo SURA',
      url: URLS.GRUPO_SURA,
    },
    {
      title: 'SURA Asset Management',
      url: URLS.SURA_ASSET_MANAGEMENT,
    },
    {
      title: 'Suramericana',
      url: URLS.SURAMERICANA,
    },
    {
      title: 'Fundación SURA',
      url: URLS.FUNDACION_SURA,
    },
  ],
  oficinas: [
    {
      title: 'CDMX',
      url: URLS.CDMX,
    },
    /* {
      title: 'Monterrey',
      url: '',
    },
    {
      title: 'Guadalajara',
      url: '',
    },
    {
      title: 'Ver lista completa',
      url: '',
    },
    {
      title: 'Fundación SURA',
      url: URLS.FUNDACION_SURA,
    }, */
  ],
  servicios: [
    {
      title: 'Condiciones Generales',
      url: URLS.CONDICIONES_GENERALES,
    },
    {
      title: 'Básicos estandarizados',
      url: URLS.BASICOS_ESTANDARIZADOS,
    },
    {
      title: 'Red Médica',
      url: URLS.RED_MEDICA,
    },
    {
      title: 'Tabulador Quirúrgico',
      url: URLS.TABULADOR_QUIRURGICO,
    },
    {
      title: 'GeoSURA',
      url: URLS.GEOSURA,
    },
    {
      title: 'Talento Humano',
      url: URLS.TALENTO_HUMANO,
    },
  ],
  legales: [
    {
      title: 'Aviso de privacidad',
      url: URLS.AVISO_PRIVACIDAD,
    },
    {
      title: 'Atención a usuarios',
      url: URLS.ATENCION_USUARIOS,
    },
    {
      title: 'Seguridad informática',
      url: URLS.SEGURIDAD_INFORMATICA,
    },
    {
      title: 'Política de identificación y conocimiento del cliente',
      url: URLS.POLITICA_IDENTIFICACION,
    },
    {
      title: 'Línea ética',
      url: URLS.LINEA_ETICA,
    },
  ],
  notices: [
    {
      title: 'Aviso de privacidad integral',
      url: URLS.AVISO_PRIVACIDAD,
    },
    {
      title: 'Aviso de pago recurrente',
      url: URLS.PAYMENT_AVISO_PAGO,
    },
  ],
};
